import { useContext, useEffect, useState } from "react";
import { Button, Form, Input,Row, Col } from "antd";
import { eResultCode } from "../../utils/enum";
import useFetch from "../../hooks/useFetch";
import useToast from "../../hooks/useToast";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import { UpdateChunkAPICount } from "../../utils/api.constant";
import { UserContext } from "../../context";
import styles from "./layout-header.module.css";
import { requiredFieldValidator } from "../../utils/input.validator";
import { CloseOutlined ,CheckOutlined} from "@ant-design/icons";

type TDrawerProps = { onClose: Function };
export default function SettingsForm(props: TDrawerProps) {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const context: any = useContext(UserContext);

  // Hook to handle on load operations
  useEffect(() => {
    form.setFieldValue("chunkSize", context?.chunkSize);
  }, [context?.chunkSize]);

  // Handle on submit event
  const onFinish = async (values: { chunkSize: number }) => {
    try {
      const payload = {
        data: {
          ...values,
        },
      };
      setIsLoading(true);

      const response = await post(UpdateChunkAPICount, payload);
      if (response.dataResponse.returnCode === eResultCode.SUCCESS) {
        onShowToast({
          type: ToastType.success,
          title: <CheckOutlined />,
          position: ToastOpen.centerTop,
          content: response.dataResponse.description,
        });
        context?.onUpdate({
          ...context,
          chunkSize: values.chunkSize,
        });
        form.resetFields();
        props.onClose();
      } else {
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: response.dataResponse.description,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Resets the district field and fetches the list of cities based on the selected state
   */

  return (
    <Form form={form} name="register" onFinish={onFinish} layout="vertical">
      <Row gutter={16} className="formRowHeight">
        <Col span={24}>
          <Form.Item
            name="chunkSize"
            label={<span className={styles.customLabel}>Chunk Size</span>}
            rules={[
              {
                required: true,
                validator: requiredFieldValidator("chunk size"),
              },
            ]}
          >
            <Input type="number" placeholder="Enter chunk size" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="" style={{ justifyContent: "center" }}>
        <Col span={4}>
          <Button type="primary" onClick={form.submit} disabled={isLoading}>
            Save
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type="primary"
            onClick={() => props.onClose()}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
